class NBDSellingPlans extends HTMLElement {

  static observedAttributes = [
    "data-variant-id",
    "data-plan-id",
    "data-plan-type",
  ];

  constructor() {
    super();
  }

  connectedCallback() {
    this.selectElements.forEach(el => el.addEventListener('change', this.handlePlanChange.bind(this)));
    this.radioInputs.forEach(el => el.addEventListener('change', this.handlePlanTypeChange.bind(this)));
    this.addEventListener('serving:change', this.handleServingChange.bind(this));
  }

  disconnectedCallback() {
    this.selectElements.forEach(el => el.removeEventListener('change', this.handlePlanChange.bind(this)));
    this.radioInputs.forEach(el => el.removeEventListener('change', this.handlePlanTypeChange.bind(this)));
    this.removeEventListener('serving:change', this.handleServingChange.bind(this));
  }

  handlePlanChange(event) {
    this.planId = event.target.value;
    this.syncPlanSelection(this.planId);
  }

  syncPlanSelection(id) {
    this.querySelectorAll('option').forEach(option => option.selected = option.value == id);
  }

  handlePlanTypeChange(event) {
    this.planType = event.target.value;
  }

  handleServingChange(event) {
    this.serving = event.detail;
    this.renderPricePerServing();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.render();
  }

  render() {
    this.toggleActivePlan();
    this.toggleActivePlanType();
    this.renderPrices();
  }

  toggleActivePlan() {
    this.selectElements.forEach(select => {
      select.classList.toggle('active', select.dataset.variantId == this.variantId)
    })
  }

  toggleActivePlanType() {
    this.radioInputs.forEach(input => {
      input.checked = (input.value === this.planType);
    })
  }

  renderPrices() {
    let option = this.currentOptionEl;
    if (!option) return;
    let { price, planPrice, saving, savingType } = option.dataset;
    price = parseInt(price);
    this.querySelectorAll('.onetime .prices').forEach(el => el.innerHTML = this.pricesHtml(price, ''));
    planPrice = parseInt(planPrice);
    planPrice = isNaN(planPrice) ? 0 : planPrice;
    if (price > planPrice) {
      this.querySelectorAll('.recurring .prices').forEach(el => el.innerHTML = this.pricesHtml(planPrice, price));
      this.querySelectorAll('.plan_badge').forEach(el => el.innerHTML = `Save ${saving}`);
    }
  }

  pricesHtml(price, compare_at_price) {
    let compare = '';
    if (compare_at_price > 0) {
      compare = `<span class="price compare-at-price">${this.formatMoney(compare_at_price)}</span>`
    }

    return `
    ${compare}
    <span class="price">${this.formatMoney(price)}</span>
    `;
  }

  clearPricePerServing() {
    this.querySelectorAll('.price-per-serving').forEach(el => el.innerHTML = '');
  }

  renderPricePerServing() {
    let option = this.currentOptionEl;
    let { label, units } = this.serving;
    if (!option || units < 1) {
      this.clearPricePerServing();
      return;
    };
    let { price, planPrice } = option.dataset;
    this.querySelectorAll('.onetime .price-per-serving').forEach(
      el => el.innerHTML = this.pricePerServingHtml(price, units, label)
    );
    this.querySelectorAll('.recurring .price-per-serving').forEach(
      el => el.innerHTML = this.pricePerServingHtml(planPrice, units, label)
    );
  }

  pricePerServingHtml(pps, units, label) {
    let price = this.formatMoney(pps / units);
    return `
      <span class="pps-price">${price}</span>
      <span class="pps-label">${label}</span>
    `;
  }

  formatMoney(value) {
    return window.NBD.formatMoney(value);
  }

  get RECURRING() {
    return 'recurring';
  }

  get planId() {
    return parseInt(this.dataset.planId);
  }

  set planId(id) {
    this.dataset.planId = id;
    this.planType = this.RECURRING;
    this.dispatchEvent(new CustomEvent("plan:change", { bubbles: true, detail: id }));
  }

  get planType() {
    return this.dataset.planType;
  }

  set planType(value) {
    this.dataset.planType = value;
    this.dispatchEvent(new CustomEvent("plan-type:change", { bubbles: true, detail: value }));
  }

  get variantId() {
    return parseInt(this.dataset.variantId);
  }

  set variantId(id) {
    this.dataset.variantId = id;
  }

  get selectElements() {
    return this.querySelectorAll('select');
  }

  get radioInputs() {
    return this.querySelectorAll('[type="radio"]');
  }

  get currentOptionEl() {
    return this.querySelector(`select[data-variant-id="${this.variantId}"] option[value="${this.planId}"]`);
  }

}

customElements.define('nbd-selling-plans', NBDSellingPlans)
